import { Handle, Position } from "@xyflow/react";
import { memo } from "react";

const MotorizadoNode = ({ data }: any) => {
  return (
    <div className="rounded-lg relative">
      <img
        src={require("../assets/motorizado.png")}
        alt="Motorizado"
        className="rounded-full"
        style={{ width: "50px", height: "50px" }}
      />

      <Handle type="source" position={Position.Left} isConnectable id="left" />
      <Handle type="target" position={Position.Left} isConnectable id="left" />

      <Handle
        type="source"
        position={Position.Right}
        isConnectable
        id="right"
      />
      <Handle
        type="target"
        position={Position.Right}
        isConnectable
        id="right"
      />
    </div>
  );
};

export default memo(MotorizadoNode);
